var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgXcircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58333 8.91667L8 7.5M8 7.5L9.41667 6.08333M8 7.5L6.58333 6.08333M8 7.5L9.41667 8.91667M14.375 7.5C14.375 11.0208 11.5208 13.875 8 13.875C4.47918 13.875 1.625 11.0208 1.625 7.5C1.625 3.97918 4.47918 1.125 8 1.125C11.5208 1.125 14.375 3.97918 14.375 7.5Z",
    stroke: "#D12B3F",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXcircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/xcircle.14930c2a.svg";
export { ForwardRef as ReactComponent };